import ProductData from "./ProductData";
import apiCoveringDataSchema from "../../services/bimVisualizerApi/schema/productData/apiCoveringDataSchema";
import { ElementTypeEnum } from "../../elementTypeMappings";
import IfcCoveringTypeEnum from "../../enums/IfcCoveringTypeEnum";

export default class CoveringData extends ProductData {

    coveringType: IfcCoveringTypeEnum;
    isSkirting: boolean;

    constructor(mappingId: string | undefined, coveringType: string, isSkirting: boolean) {
        super(ElementTypeEnum.Covering, mappingId);
        this.coveringType = (coveringType in IfcCoveringTypeEnum)
            ? (IfcCoveringTypeEnum as any)[coveringType]
            : IfcCoveringTypeEnum.USERDEFINED;
        this.isSkirting = isSkirting;
    }

    static fromJSON(json: any): ProductData {

        const parsed = apiCoveringDataSchema.parse(json);

        return new CoveringData(    parsed.mappingId ?? undefined, 
                                    parsed.coveringType,
                                    parsed.isSkirting);

    }
}